"use strict";

class CustomerVideosController {

    constructor($timeout, SSUtilService, SSConfigService) {
        const self = this;

        self.$timeout = $timeout;

        self.SSUtilService = SSUtilService;
        self.SSConfigService = SSConfigService;

        self.data = SHOWSUITE.data;

        self.init();
    }

    init() {
        const self = this;
        self.loadYoutubeChannelVideos();
    }

    loadYoutubeChannelVideos() {
        const self = this;

        self.channels = [];
        if (self.data.channels) {
            self.channels = self.data.channels;
        }

        self.selectedVideo = self.findVideo(self.data.selected_video_id);
    }

    findVideo(videoId) {
        const self = this;

        let video = null;

        if (videoId && self.channels && self.channels.items) {
            jQuery.each(self.channels.items, function (i, channel) {
                jQuery.each(channel.items.items, function (j, _video) {
                    if (_video.contentDetails.videoId == videoId) {
                        video = _video;
                        return false;
                    }
                });
                if (video) {
                    return false;
                }
            });
        }

        return video;
    }

    getSelectedVideoUrl() {
        const self = this;

        if (self.selectedVideo) {
            return self.SSUtilService.trustSrc('https://www.youtube.com/embed/' + self.selectedVideo.contentDetails.videoId + '?rel=0&autoplay=1');
        }
    }
}

CustomerVideosController.$inject = ['$timeout', 'SSUtilService', 'SSConfigService'];
app.controller('CustomerVideosController', CustomerVideosController);
